module.exports = __webpack_public_path__ + "static/media/300-300_Hosgeldiniz.da934a6c.png";